import { render, staticRenderFns } from "./linkForm.vue?vue&type=template&id=3738636e"
import script from "./linkForm.vue?vue&type=script&lang=js"
export * from "./linkForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports